'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { I18N_FETCH } from 'DesignData/actions/ActionTypes';
export default function Portal(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case I18N_FETCH:
      {
        const {
          i18nInfo,
          error
        } = action;
        if (!i18nInfo || error) return state;
        return SeamlessImmutable(i18nInfo);
      }

    default:
      return state;
  }
}